const prefix = 'fasr';
const iconName = 'arrow-turn-down-left';
const width = 512;
const height = 512;
const aliases = [];
const unicode = 'e2e1';
const svgPathData = 'M464 56V32h48V56 288v24H488 93.1l79 79 17 17-33.9 33.9-17-17L18.2 305l-17-17 17-17 120-120 17-17L189.1 168l-17 17-79 79H464V56z';

export default {
  prefix,
  iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ] };
